module.exports = __webpack_public_path__ + "img/v32.03c79cb9.03c79cb9.svg";